<template>
    <layout :showuserinfo="false">
        <div class="container-fluid ">
            <div class="page-wrapper-portal" style="background-color:#ffcf00">
                <MenuNav :text-color="'white'" />
                <Menu :auth="auth" :link="'utama'" />
                <div class="container container-fluid" >

                    <div class="input-group px-3" >
                        <input type="text" style="border-top-left-radius: 50px;border-bottom-left-radius: 50px;" class="form-control" placeholder="Sila Masukkan No. Hak Milik / No. Akaun "
                            v-model="no_rujukan">
                        <button class="btn bg-hitam" @click="carian(0)" type="button" style="border-top-right-radius: 50px;border-bottom-right-radius: 50px;">
                            <i class="fa fa-search " style="color:#ffcf00"></i>
                        </button>
                    </div>

                    <div class="row d-flex justify-content-center">
                        <div class="row py-2 px-3">
                            <swiper class="swiper rounded" :slides-per-view="1" :space-between="50" :scrollbar="{ draggable: true }"
                                :loop="loop" :autoplay="autoplay" @swiper="onSwiper" @slideChange="onSlideChange">
                                <swiper-slide v-for="(item, id) in slider" :key="id" >

                                    <div class="d-flex justify-content-center" style="width: 100%;">
                                        <img :src="`assets/images/banner/${item.filename}`" style="width: 100%;">
                                    </div>
                                </swiper-slide>

                            </swiper>
                        </div>

                        <!-- <div class="row d-flex justify-content-center mb-2">
                            <div class="col-4">
                                <div class="card">
                                    <div class="card-body">
                                        Pendidikan
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="card">
                                    <div class="card-body">
                                        Perumahan
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div> 




                </div>






            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffcf00" fill-opacity="1" d="M0,128L80,117.3C160,107,320,85,480,112C640,139,800,213,960,218.7C1120,224,1280,160,1360,128L1440,96L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path></svg>
        </div>
        <!-- <div class="row d-flex mt-2">
            <div class="justify-content-center">

                <div class="card border mx-2 bg-white text-dark round shadow">
                    <div class="card-body pkn-banner-title-4-des">
                        <div v-html="pengumuman_selected"></div>
                    </div>


                </div>
                <br />
            </div>
        </div>-->
        <div class="row d-flex">
            
            <template v-if="$props.pendidikan == '' && $props.perumahan ==''">
                <h6 class="text-center mt-3">TIADA BIL BERDAFTAR ATAS NOMBOR KAD PENGENALAN ANDA</h6>
            </template>
            <template v-else>
                <h4  class="text-center mt-3">AKAUN SEMASA SAYA</h4>
                <swiper
                :slidesPerView="2"
                :spaceBetween="10"
                :pagination="{
                clickable: true,
                }"
                :modules="modules"
                class="mySwiper"
            >
                <swiper-slide v-for="item in pendidikan" :key="item.id">
                    <div class="card card-bil" @click="goToCarian(item.IC_BARU)" style="border-radius: 20px;">
                        <div class="card-body ">
                            <i class="mdi mdi-book font-16 me-2"></i><strong><h5>PENDIDIKAN</h5></strong>
                            <span class="badge bg-dark "><h6>RM {{ item.ANSURAN_BULANAN }}</h6></span>
                        </div>
                    </div>
                </swiper-slide>
                    <swiper-slide v-for="item in perumahan" :key="item.id">
                    <div class="card card-bil" style="border-radius: 20px;">
                        <div class="card-body">
                            <i class="mdi mdi-home font-16 me-2"></i><strong><h5>PERUMAHAN</h5></strong>
                            <span class="badge bg-dark text-dark"><h6>RM {{ item.JUMLAH_SEWA_BAYAR }}</h6></span>
                         
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            </template>
            <!--<swiper class="swiper-card" :pagination="pagination">
                <swiper-slide v-for="item in pendidikan" :key="item.id">
                    <div class="card card-bil">
                    <div class="card-body">
                        <h5>PENDIDIKAN</h5>
                        <strong>Ansuran Bulanan</strong><br />
                        {{ item.ANSURAN_BULANAN }}<br />
                        <br />
                        <strong>Jumlah Baki</strong><br />
                        {{ item.JUMLAH_BAKI }}<br />
                    </div>
                    </div>
                </swiper-slide>
            </swiper>-->

            
          
        </div>

        <div class="row d-flex mt-2">
            <swiper class="swiper-card" :pagination="pagination" :loop="loop" :autoplay="autoplay" @swiper="onSwiper" @slideChange="onSlideChange">
                <swiper-slide v-for="(item, id) in pengumumans" :key="id">
                    <div class="card card-pengumumans" style="border-radius: 10px;" @click="modalPengumuman(item.content)">
                    <div class="card-body">
                        {{ item.content }}
                    </div>
                    </div>
                </swiper-slide>
            </swiper>
          
        </div>

        <!-- <div class="row py-2 px-3">
            <swiper class="swiper rounded" :slides-per-view="1" :space-between="50" :scrollbar="{ draggable: true }"
                :loop="loop" :autoplay="autoplay" @swiper="onSwiper" @slideChange="onSlideChange">
                <swiper-slide v-for="(item, id) in slider" :key="id" >

                    <div class="d-flex justify-content-center" style="width: 100%;">
                        <img :src="`assets/images/banner/${item.filename}`" style="width: 100%;">
                    </div>
                </swiper-slide>
            </swiper>
        </div> -->
        <w-dialog v-model="dialogPengumuman.show" :fullscreen="dialogPengumuman.fullscreen"
            :persistent="dialogPengumuman.persistent"
            :persistent-no-animation="dialogPengumuman.persistentNoAnimation" title-class="primary-light1--bg white">
            <template #title>
            <!-- <w-icon class="mr2">fal fa-pencil</w-icon> -->
            Pengumuman
            </template>
            <div class="page-wrapper-portal">
            <div class="row">
                {{ selectedPengumumanContent }}
            </div>
            </div>

            <template #actions>
            <div class="spacer" />
            <w-button bg-color="grey-light5--bg" @click="dialogPengumuman.show = false">Tutup</w-button>
            </template>
        </w-dialog>
        


    </layout>
</template>
  
<script type="text/javascript">
import Menu from '../Menu.vue'
import MenuNav from '../MenuNav.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Autoplay, Pagination, Scrollbar } from 'swiper/core';

import 'swiper/css'
import 'swiper/css/navigation'

SwiperCore.use([Autoplay, Pagination, Scrollbar]);

export default {
    components: {
        Menu, MenuNav, Swiper, SwiperSlide,

    },
    setup() {
        const onSwiper = (swiper) => {
            console.log(swiper);
        };
        const onSlideChange = () => {
            console.log('slide change');
        };
        return {
            onSwiper,
            onSlideChange,
        }
    },
    props: {
        auth: [Array, Object],
        datas: [Array, Object],
        sumber: [Array, Object],
        cara_terimaan: [Array, Object],
        profil_id: [Array, Object],
        nama: [Array, Object],
        pengumumans: [Array, Object],
        perumahan: [Array, Object],
        pendidikan: [Array, Object],
        slider: [Array, Object],


    },
    data() {
        return {
            pagination: {
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
            },
            modules: [Pagination],
            cardData: [], // Add this property for card data
            isCertainPage: true,
            autoplay: {
                loop: true,
                delay: 4000,
            },
            lkp_sumber_id: '',
            lkp_cara_terimaan_id: '',
            no_rujukan: '',
            keterangan: '',
            tarikh_bayar: '',
            no_resit: '',
            resit_id: 0,
            senarai: [],
            total_carian: 0.00,
            total_pilih: 0.00,
            cari: 0,
            pilih: false,
            form: {
                pengumuman: 1,
            },
            selectedPengumumanContent: '',
            dialogPengumuman: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
            },
            no_pengumuman: 0,
            pengumuman_selected: '',
            cari: { lkp_sumber_id: '', lkp_cara_terimaan_id: '', no_rujukan: '', keterangan: '', tarikh_bayar: '', no_resit: '', payment_id: '' },
        }
    },
    methods: {
        modalPengumuman(content) {
            this.selectedPengumumanContent = content;
            this.dialogPengumuman.show = true;
        },

        goToCarian(a){
            this.$inertia.visit(window.route('landing.carian') + '?no_rujukan=' + a, { preserveState: true, onSuccess: () => { return Promise.all([this.total(),]) } })
        },
        carian(c) {
            // this.cari.no_rujukan = this.no_rujukan
            this.loading = 1;
            if (c == 1) {

                this.$inertia.visit(window.route('landing.carian') + '?c=1&no_hm=' + this.form_carian.no_hm + '&no_akaun=' + this.form_carian.no_akaun + '&no_lot=' + this.form_carian.no_lot + '&lkp_mukim_id=' + this.form_carian.lkp_mukim_id + '&lkp_daerah_id=' + this.form_carian.lkp_daerah_id + '&lkp_hm_jenis_id=' + this.form_carian.lkp_hm_jenis_id, { preserveState: true, onSuccess: () => { return Promise.all([this.total(),]) } })
            } else {
                this.$inertia.visit(window.route('landing.carian') + '?c=0&no_rujukan=' + this.no_rujukan, { preserveState: true, onSuccess: () => { return Promise.all([this.total(),]) } })
            }
        },
        reset() {
            this.cari = { lkp_sumber_id: '', lkp_cara_terimaan_id: '', no_rujukan: '', keterangan: '', tarikh_bayar: '', no_resit: '', payment_id: '' }
            this.carian()
        },
        cekPilih() {

            for (var i in this.datas) {
                this.datas[i].pilih = this.pilih
            }
        },

        pilihPengumuman(pengumuman) {
            this.pengumuman = pengumuman
        },
        getPengumuman(id = null) {
            if (id != null) {
                this.no_pengumuman
            }
            // alert(this.no_pengumuman);
            if (this.pengumumans.length > 0) {
                this.pengumuman_selected = this.pengumumans[this.no_pengumuman].content
                var no = this.pengumumans.length - 1;
                if (this.no_pengumuman != no) {

                    this.no_pengumuman = this.no_pengumuman + 1
                } else {
                    this.no_pengumuman = 0
                }
                setTimeout(() => (this.getPengumuman()), 15000)
            }
        },
        cetak() {
            var id = '';
            for (var i in this.datas) {
                if (this.datas[i].pilih == true) {

                    id = this.datas[i].id + ',' + id

                }
            }
            if (id) {
                window.location.href = route("landing.cetak", id) + '?profil_id=' + this.profil_id;

            } else {
                alert('sila pilih dulu.')
            }
        },

        cetak_senarai() {
            var id = '';
            for (var i in this.datas) {
                if (this.datas[i].pilih == true) {

                    id = this.datas[i].id + ',' + id

                }
            }
            if (id) {
                // window.location.href = route("landing.cetak_senarai",id)+'?profil_id='+this.profil_id;
                window.open(route("landing.cetak_senarai", id) + '?profil_id=' + this.profil_id, '_blank');

            } else {
                alert('sila pilih dulu.')
            }
        },

    },
    mounted() {
        this.cardData = [
            { text: 'Card 1 content' },
            { text: 'Card 2 content' },
        ];
        this.getPengumuman();
        this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

        if (this.cari.lkp_sumber_id) {
            this.lkp_sumber_id = this.cari.lkp_sumber_id
            this.carian();
        }
        if (this.cari.lkp_cara_terimaan_id) {
            this.lkp_cara_terimaan_id = this.cari.lkp_cara_terimaan_id
            this.carian();
        }
        if (this.cari.resit_id) {
            this.resit_id = 1;
        }
    },
    updated() {
        this.swiperInstance.update(); // Update Swiper instance when data changes
    },
}
</script>
<style type="text/css">
.pkn-carian-landing {
    position: inherit !important;
}

.table-responsive {
    position: relative !important;
    height: 550px !important;
}

.container .second-layer {
    background-color: white;
    padding: 10px;

}

.main-mobile {
    background-color: #F8F9FA;

}

.swiper-card {
  width: 100%;
  max-width: 800px; /* Adjust the width as needed */
  margin: 0 auto;
}

.card-pengumumans {
  border: 1px solid #ddd;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 200px;
    overflow-y: auto;
}

.card-bil {
  padding: 5px;
  margin: 5px;
  height: auto;
  width: auto;
  overflow-y: auto;
  background: rgb(255,207,0);
  background: linear-gradient(171deg, rgba(255,207,0,1) 0%, rgba(255,255,255,1) 100%);
}
.white-icon {
    color: white;
}

.row .swiper {
    max-width: 100vw;
}

.card-pengumuman {
    height: 200px;
    overflow-y: auto;
}

.pagination {
  text-align: center;
  margin-top: 15px;
}

.swiper-pagination-bullet {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #000;
  opacity: 1;
  background: rgba(0, 0, 0, 0.2);
}

.swiper-pagination-bullet-active {
  color: #fff;
  background: #007aff;
}
</style>
  